import { SessionContext } from '@/providers/SessionProvider/SessionProvider';

export const InitAppCuesIdentify = (
  currentUser: NonNullable<SessionContext['currentUser']>,
  currentClient: NonNullable<SessionContext['currentClient']>,
) => {
  const userFirstName = currentUser.fullName?.split(' ')[0] ?? '';
  const userLastName =
    currentUser.fullName?.split(' ').splice(1).join(' ') ?? '';

  window.Appcues.identify(currentUser.id, {
    // COMPANY
    company: currentClient.id,
    salesForceId: '', // DV does not have this data
    // USER
    email: currentUser.email,
    firstName: userFirstName,
    lastName: userLastName,
    role: '', // TODO: check what should be set
  });

  window.Appcues.group(currentClient.id, {
    companyName: currentClient.displayName,
    companyId: currentClient.id,
    companySalesforceId: '',
  });
};

export const setupLaunchPadStyling = () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (
          node.nodeType === 1 &&
          (node as Element).tagName === 'APPCUES-EXPERIENCE-CONTAINER'
        ) {
          const interval = setInterval(() => {
            const shadowRoot = (node as Element & { shadowRoot?: ShadowRoot })
              .shadowRoot;
            if (shadowRoot) {
              const styleElement = document.createElement('style');
              styleElement.textContent = `
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

                #launchpad-container {
                    font-family: 'Inter', sans-serif !important;
                    background: white !important;
                }

                #launchpad-container header {
                    font-family: 'Inter', sans-serif !important;
                    color: rgb(33, 33, 33) !important;
                    background: white !important;
                }
            `;
              shadowRoot.appendChild(styleElement);
              clearInterval(interval);
            }
          }, 2);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
};
